import router from "../router";
import i18n from "../i18n";
import { createPayment } from "../modules/cloudpayments";

const lang = i18n.locale.slice(0, 2);

const serialize = obj =>
    Object.keys(obj)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
        .join("&");

const store = {
    namespaced: true,

    state: {
        fetching: false,
        error: false,
    },

    mutations: {
        SET_FETCHING(state) {
            state.fetching = true;
        },

        SET_COMPLETE(state) {
            state.fetching = false;
        },

        SET_ERROR(state) {
            state.fetching = false;
            state.error = true;
        },
    },

    actions: {
        async submitData({ commit }, { type, id, data }) {

            console.log(type, id, data);

            if (type !== 'order') {
                try {
                    commit("SET_FETCHING");
    
                    const options = {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                        },
                        body: JSON.stringify(data),
                    };
    
                    const q = serialize({ lang, ...router.currentRoute.query });
    
                    const response = await fetch(`/api/${type}/${id}/tickets?${q}`, options);
    
                    if (response.status === 201) {
                        const payload = await response.json();
    
                        commit("data/SET_TICKET", payload, { root: true });
    
                        return commit("SET_COMPLETE");
                    }
    
                    if (response.status >= 200 && response.status < 300) {
                        const payload = await response.json();
    
                        window.localStorage.setItem("@private/token", payload.token);
    
                        if (data.payment === "cloudpayments") {
                            window.localStorage.setItem("@private/token", response.headers.get("access-token"));

                            var descr = i18n.t("headlines.buy_ticket") + " #" + payload.orderNumber;

                            console.log(payload);

                            createPayment({
                                email: data.email,
                                amount: Number(payload.amount),
                                ticketId: payload.orderNumber,
                                entity: type,
                                entityID: router.currentRoute.params.id,
                                descr: descr,
                                publicId: payload.publicId,
                                access_token_url_safe: response.headers.get("access-token-url-safe")
                            });
                        } else {
                            location.href = payload.payload;
                        }
    
                        return commit("SET_COMPLETE");
                    }
    
                    throw await response.text();
                } catch (error) {
                    commit("SET_ERROR");
                }
            } else {

                try {
                    commit("SET_FETCHING");

                    data.orderid = id;
    
                    const options = {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                        },
                        body: JSON.stringify(data),
                    };
    
                    const q = serialize({ lang, ...router.currentRoute.query });
    
                    const response = await fetch(`/api/${type}/${id}/payload?${q}`, options);
    
                    if (response.status === 201) {
                        const payload = await response.json();
    
                        commit("data/SET_TICKET", payload, { root: true });
    
                        return commit("SET_COMPLETE");
                    }
    
                    if (response.status >= 200 && response.status < 300) {
                        const payload = await response.json();

                        if (payload.paid) {
                            router.push("/paid?returning_uri=" + payload.returning_uri);
                            return commit("SET_COMPLETE");
                        }

                        window.localStorage.setItem("@private/token", payload.token);
    
                        if (data.operatorType === "cloudpayments") {
                            window.localStorage.setItem("@private/token", response.headers.get("access-token"));
    
                            createPayment({
                                email: data.email,
                                amount: Number(payload.amount),
                                ticketId: payload.orderNumber,
                                entity: type,
                                entityID: router.currentRoute.params.id,
                                descr: payload.descr,
                                operatorId: payload.operatorId,
                                operatorType: payload.operatorType,
                                publicId: payload.publicId,
                                returning_uri: payload.returning_uri,
                            });
                        } else {
                            if (+payload.ok === 1) {
                                location.href = payload.payload;
                            } else {
                                router.push(
                                    "/notifications/payment/failed?reference=" + router.currentRoute.fullPath + "&returning_uri=" + payload.returning_uri,
                                );
                            }
                        }
    
                        return commit("SET_COMPLETE");
                    }
    
                    throw await response.text();
                } catch (error) {
                    commit("SET_ERROR");
                }

            }

            

        },
    },
};

export default store;
